if (!window.pyvDonationModalBound) {
  window.pyvDonationModalBound = true;

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-awd-open]');
    if (opener) {
      var modal = document.getElementById(opener.getAttribute('data-awd-target'));
      if (modal) {
        if (modal.parentNode !== document.body) {
          document.body.appendChild(modal);
        }
        modal.hidden = false;
        document.body.classList.add('pyv-donation-modal-open');
      }
      return;
    }

    var closer = event.target.closest('[data-awd-close]');
    if (closer) {
      var openModal = closer.closest('[data-awd-modal]');
      if (openModal) {
        openModal.hidden = true;
        document.body.classList.remove('pyv-donation-modal-open');
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-awd-modal]:not([hidden])').forEach(function (modal) {
      modal.hidden = true;
    });
    document.body.classList.remove('pyv-donation-modal-open');
  });
}
